





<div class="animate__animated animate__jackInTheBox" style="text-align: center; justify-content: center;margin-top: 15vh;">
  <strong  style="font-size: 4vh; "></strong>
</div>


<section class="photos-section py-5 d-flex justify-content-center" >
  <div class="container">
    <div class="row" >



      <div class="col-12 col-sm-6 col-xl-6 d-flex card-outer animate__pulse" style="text-align: center; justify-content: center;"data-aos="fade-up">
        <a href="admin/proteccion-civil/dictamen/registro" class="card-title">
          <div class="card ">
            <div class="position-relative" style="text-align: center; justify-content: center;">
              <img style="margin-top: 2vh;border-radius: 2vh;" height="250" width="250" src="https://i.imgur.com/7xitkdA.png"
                class="card-img-top " alt="">
                <svg class="position-absolute w-100" style="border: 0px;border-color: rgba(255, 255, 255, 0);">
                  <use xlink:href="#two" style="border: 0px; border-color: rgba(255, 255, 255, 0);"></use>
                </svg>
            </div>
            <div class="card-body">

              <strong>Registrar Nuevo Dictamen</strong>

            </div>
          </div>
        </a>
      </div>


      <div class="col-12 col-sm-6 col-xl-6 d-flex card-outer animate__pulse" style="text-align: center; justify-content: center;"data-aos="fade-up">
        <a href="admin/proteccion-civil/dictamen/lista" class="card-title">
          <div class="card ">
            <div class="position-relative" style="text-align: center; justify-content: center;">
              <img style="margin-top: 2vh;border-radius: 2vh;" height="250" width="250" src="https://i.imgur.com/dVrbHZK.png"
                class="card-img-top " alt="">
                <svg class="position-absolute w-100" style="border: 0px;border-color: rgba(255, 255, 255, 0);">
                  <use xlink:href="#two" style="border: 0px; border-color: rgba(255, 255, 255, 0);"></use>
                </svg>
            </div>
            <div class="card-body">

              <strong>Lista de Dictamenes</strong>

            </div>
          </div>
        </a>
      </div>















